import axios from "axios";
import CryptoJS from "crypto-js";

const preset = process.env.REACT_APP_UPLOAD_PRESET;
const cloudinaryName = process.env.REACT_APP_CLOUDINARY_NAME;
const apiKey = process.env.REACT_APP_API_KEY;
const apiSecret = process.env.REACT_APP_API_SERECT;
export const ImageService = {
  uploadMany: async (files) => {
    try {
      const promises = files.map(async (file) => {
        if (!file?.name || !file.size) return file?.preview ?? file;
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", preset);
        formData.append("folder", "buchfuhrung");

        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/${cloudinaryName}/image/upload`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 200) {
          console.log("URL:", response.data.secure_url);
          return response.data.secure_url;
        } else {
          console.error("Image upload failed.");
        }
      });
      try {
        const urls = await Promise.all(promises);
        return urls.filter((url) => url !== "");
      } catch (error) {
        console.error("Error uploading files: ", error);
      }
    } catch (error) {
      console.error("Error uploading files: ", error);
    }
  },
  uploadBaseImage: async (base64Images) => {
    const uploadedImageUrls = [];
    try {
      for (const base64Image of base64Images) {
        const formData = new FormData();
        formData.append("file", base64Image);
        formData.append("upload_preset", preset);
        formData.append("folder", "Accounting");
        const result = await axios.post(
          `https://api.cloudinary.com/v1_1/${cloudinaryName}/image/upload`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        uploadedImageUrls.push(result.data.url);
      }
      return uploadedImageUrls;
    } catch (error) {
      throw error;
    }
  },
  deleteImage: async (imageUrl) => {
    const generateSignature = (publicId, apiSecret, timestamp) => {
      const dataToSign = `public_id=${publicId}&timestamp=${timestamp}`;
      const signature = CryptoJS.SHA1(dataToSign + apiSecret).toString(CryptoJS.enc.Hex);
      return signature;
    };
    const startIndex = imageUrl?.indexOf("Accounting");
    const endIndex = imageUrl?.lastIndexOf(".");
    let publicId;
    if (startIndex !== -1 && endIndex > startIndex) {
      publicId = imageUrl.substring(startIndex, endIndex);
    } else {
      console.log("Invalid URL format or '/Accounting' not found.");
    }
    const timestamp = new Date().getTime();
    const signature = generateSignature(publicId, apiSecret, timestamp);
    try {
      const formData = new FormData();
      formData.append("public_id", publicId);
      formData.append("timestamp", timestamp);
      formData.append("signature", signature);
      formData.append("folder", "Accounting");
      const result = await axios.post(
        `https://api.cloudinary.com/v1_1/${cloudinaryName}/image/destroy`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          params: {
            api_key: apiKey,
            timestamp: timestamp,
          },
        }
      );
      return result.data;
    } catch (error) {
      throw error;
    }
  },
};
